// ============================================
// Personality Sliders
// ============================================

export function initPersonalitySliders() {
    jQuery('.personality-range-slider').each(function () {
        const $input = jQuery(this);
        const value = $input.val();
        $input.css('--slider-progress', value + '%');
    });
}

export function bindSliderInputHandler() {
    jQuery(document).off('input.sliders').on('input.sliders', '.personality-range-slider', function () {
        const $input = jQuery(this);
        const name = $input.attr('name');
        const value = $input.val();
        const $wrapper = $input.closest('.quiz-slider-wrapper');
        $wrapper.find('.quiz-slider-value[data-for="' + name + '"]').text(value + '%');
    });
}


